import makeApiCall from "../master/axiosIndex";

const reportApis = {
  fetchPMSReports: (data: any) => {
   return makeApiCall({
      method: "get",
      url: "/pms-reports/list",
      params: data,
    });
  },
  fetchExpenseReports: (data: any) => {
    return makeApiCall({
      method: "get",
      url: "/pms-reports/ExpenseReports/list",
      params: data,
    });
  },
};

export default reportApis;
